import { atom } from "recoil";

const sidebarStore = atom<boolean>({
	key: "sidebarStore",
	default: true,
});

export default sidebarStore;
